// 上门服务报错 Model

import cloneDeep from 'lodash/cloneDeep';
import { produce } from 'immer';
import pick from 'lodash/pick';

/**
 * @typedef AttachedAddressState
 * @prop {string} attachedShopName
 * @prop {number|null} districtId 点评ID
 * @prop {string} address
 * @prop {number|null} phone
 * @prop {{longitude: number, latitude: number}|null} location
 */

/**
 * @type AttachedAddressState
 */
const AttachedAddress = {
  attachedShopName: '',
  districtId: null,
  address: '',
  location: null,
  phone: null,
};

/**
 * @typedef DistanceChargeDetailState
 * @prop {number} index
 * @prop {number} distance
 * @prop {number} chargeValue
 */

/**
 * @typedef ChargeRuleState
 * @prop {number} openFlag
 * @prop {number} scopeType
 * @prop {number} scopeRadius
 * @prop {number|null} chargeType
 * @prop {number} chargeValue
 * @prop {number} freeChargeValue
 * @prop {DistanceChargeDetailState[]} distanceChargeDetails
 */

/**
 * @type ChargeRuleState
 */
export const ChargeRule = {
  openFlag: null,
  scopeType: null,
  scopeRadius: null,
  chargeType: null,
  chargeValue: null,
  freeChargeValue: null,
  distanceChargeDetails: null,
};

export const DefaultDistanceChargeDetails = [
  {
    index: 0,
    distance: null,
    chargeValue: null,
  },
  {
    index: 1,
    distance: null,
    chargeValue: null,
  },
];

/**
 * @typedef ReportServiceState
 * @property {AttachedAddressState[]} attachedAddress
 * @property {ChargeRuleState} chargeRule
 */

export default {
  namespace: 'reportService',
  /**
   * @type {ReportServiceState}
   */
  state: {
    attachedAddressUid: 0,
    attachedAddress: [],
    attachedAddressFormRefs: {},
    chargeRule: null,
    chargeRuleFormRef: null,
  },
  reducers: {
    updateChargeRule(state, { payload }) {
      return produce(state, draft => {
        if (!draft.chargeRule) {
          draft.chargeRule = cloneDeep(ChargeRule);
        }
        Object.keys(payload).forEach(key => {
          draft.chargeRule[key] = payload[key];
        });
      });
    },
    updateChargeRuleFormRef(state, { payload }) {
      return produce(state, draft => {
        draft.chargeRuleFormRef = payload;
      });
    },
    initAttachedAddress(state, { payload }) {
      return produce(state, draft => {
        draft.attachedAddress =
          payload?.map((i, index) => ({
            ...pick(i, ['attachedShopName', 'districtId', 'address', 'phone']),
            location: { lng: i.lng, lat: i.lat },
            uid: index,
          })) || [];
        draft.attachedAddressUid = draft.attachedAddress.length;
      });
    },
    updateAttachedAddress(state, { payload }) {
      const { index, ...data } = payload;
      return produce(state, draft => {
        Object.keys(data).forEach(key => {
          draft.attachedAddress[index][key] = data[key];
        });
      });
    },
    removeAttachedAddress(state, { payload: index }) {
      return produce(state, draft => {
        draft.attachedAddress.splice(index, 1);
        draft.attachedAddressFormRefs[index] = null;
      });
    },
    updateAttachedAddressFormRef(state, { payload }) {
      return produce(state, draft => {
        draft.attachedAddressFormRefs[payload.index] = payload.formRef;
      });
    },
    appendAttachedAddress(state) {
      return produce(state, draft => {
        draft.attachedAddress.push({
          ...cloneDeep(AttachedAddress),
          uid: draft.attachedAddressUid++,
        });
      });
    },
  },
};
